import React, { useContext, useRef } from 'react';
import { motion } from 'framer-motion';

import { ThemeContext } from '../../contexts/ThemeContext.js'
import './sidebar.scss'

const sidebarVariants = {
  closed: { x: 300 },
  open:   { x: 0 }
};

const Sidebar = () => {
  const { isThemeMenuOpen, setIsThemeMenuOpen, theme, setTheme, THEME_ARRAY } = useContext(ThemeContext);

  const setThemeFromSidebar = (param) => {
    setTheme(param);
    localStorage.setItem("theme", param);
  };


	const timerRef = useRef(null);

	const handleLeave = () => {
		timerRef.current = setTimeout(() => setIsThemeMenuOpen(false), 3000);
	};

	const handleEnter = () => {
		clearTimeout(timerRef.current);
		timerRef.current = null;
	};

  return (
    <motion.aside
      className="sidebar"
      variants={sidebarVariants}
      initial="closed"
      animate={isThemeMenuOpen ? "open" : "closed"}
      transition={{ duration: 0.35, ease: "easeInOut" }}
			onMouseLeave={handleLeave}
			onMouseEnter={handleEnter}
    >
      <div className="sidebar-wrapper">
				<hr />
				<h3>Standard Themes</h3>
				<div className='themes-wrapper'>
					{THEME_ARRAY.slice(25,50).map((themeObj, idx) => (
            <div
              key={`theme${idx}`}
              className="theme-button"
              title={themeObj.name}
              style={{ background: themeObj.bg, borderColor: themeObj.bg.includes(theme) ? 'chartreuse' : '' }}
              onClick={() => setThemeFromSidebar(themeObj.bg.slice(6, 13))}
            />
          ))}
				</div>
				<hr />
        <h3>Special Themes</h3>
        <div className="themes-wrapper">
          {THEME_ARRAY.slice(0,25).map((themeObj, idx) => (
            <div
              key={`theme${idx}`}
              className="theme-button"
              title={themeObj.name}
              style={{ background: themeObj.bg, borderColor: themeObj.bg.includes(theme) ? 'chartreuse' : '' }}
              onClick={() => setThemeFromSidebar(themeObj.bg.slice(6, 13))}
            />
          ))}
        </div>
        <hr />
      </div>
    </motion.aside>
  );
};

export default Sidebar;